<script setup>
import { computed, ref } from 'vue'
import { RouterView } from 'vue-router'
import NewcomerRedPacketPopup from './components/NewcomerRedPacketPopup.vue'
import { isAuthLoggedIn } from '@/utils/authStorage'

// 注释：App.vue层全局弹窗 - 确保新人红包弹窗和悬浮窗在Home和Mine页面可见
// 其他页面不展示（组件内部通过route.name判断）
// 登录成功后会自动弹出（通过auth-state-changed事件触发）

const cachedViews = ref(['addShop', 'MainLayout'])

const isLogin = computed(() => isAuthLoggedIn())
</script>

<template>
  <router-view v-slot="{ Component }" :key="isLogin">
    <keep-alive :include="cachedViews">
      <component :is="Component" />
    </keep-alive>
  </router-view>

  <!-- 新人红包弹窗组件 - 放在App层全局可用，在Home和Mine页面展示 -->
  <!-- 包含主红包弹窗、成功弹窗和右下角悬浮窗，所有交互均为假数据 -->
  <NewcomerRedPacketPopup />
</template>

<style scoped lang="scss">

</style>
